import type { LetterSenderSlice } from '../types';

export enum LetterPanelView {
  LETTER = 'letter',
  TASK = 'task',
  DRAFTING_TASK = 'drafting-task',
}

export interface UiState {
  isEditingMessageAfterFailedSend: boolean;
  letterPanelView: LetterPanelView;
}

export const uiInitialState = {
  isEditingMessageAfterFailedSend: false,
  letterPanelView: LetterPanelView.LETTER,
} satisfies UiState;

export type UiActions = {
  setIsEditingMessageAfterFailedSend: (isEditing: boolean) => void;
  setLetterPanelView: (view: LetterPanelView) => void;
};

export const createUiSlice: LetterSenderSlice<UiActions> = (set) => ({
  setIsEditingMessageAfterFailedSend: (isEditingMessageAfterFailedSend) =>
    set({ isEditingMessageAfterFailedSend }),
  setLetterPanelView: (letterPanelView) => set({ letterPanelView }),
});
